import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import { SnackbarFactory } from '@shared/services';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-file-look-popup',
  templateUrl: './file-look-popup.component.html',
  styleUrls: ['./file-look-popup.component.scss']
})
export class FileLookPopupComponent {
  public file: Blob;
  public fileName: string;
  public fileType: string;
  public fileUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) data: any,
    public snackBar: SnackbarFactory,
    private sanitizer: DomSanitizer,
  ) {
    this.file = data.file;
    this.fileName = data.fileName;
    this.fileType = data.fileType;

    let url = URL.createObjectURL(this.file);
    this.fileType === "pdf" ? url = url + "#toolbar=0" : null;

    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  downloadFile() {
    FileSaver.saveAs(this.file, this.fileName);
    this.snackBar.showDurationSnackbar('success');
  }
}
